<template>
    <div> 
        <div v-if="is_super_admin">
            <div style="padding: 0px 16px;">
                <div class="search-style">
                    <el-form :inline="true" :model="dUserSearch" class="demo-form-inline" :ref="dUserSearch" style="margin-top: 10 auto">
                        
                        <el-form-item label="用户名称" class="from-label" >
                            <el-input size="small" v-model="dUserSearch.username" placeholder="请输入用户名称" clearable></el-input>
                        </el-form-item>

                        <el-form-item label="手机号" class="from-label">
                            <el-input size="small" v-model="dUserSearch.phone_num" placeholder="请输入手机号" clearable></el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="searchUser" size="small" icon="el-icon-search">查询</el-button>
                            <el-button type="primary" @click="onReset" size="small" icon="el-icon-refresh">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <div style="padding: 10px 16px;">
                <el-table
                    :data="userList"
                    style="width: 100%;border-color:'#606266'"
                    :default-sort = "{prop: 'date', order: 'descending'}"
                    :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
                    :cell-style="{color: '#666',fontSize:'14px'}"
                    border
                    >
                    <el-table-column
                        fixed
                        align="center"
                        prop="id"
                        label="用户ID"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column  
                        align="center"
                        prop="username"
                        label="用户名称"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column  
                        align="center"
                        prop="nickname"
                        label="微信名"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column  
                        align="center"
                        prop="phone_num"
                        label="手机号"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column  
                        align="center"
                        prop="email"
                        label="邮箱"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column  
                        align="center"
                        prop="vip_info.vip_level"
                        label="会员等级"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column  
                        align="center"
                        prop="vip_info.recharge_money"
                        label="充值金额"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column  
                        align="center"
                        prop="vip_info.last_recharge_money"
                        label="上次充值金额"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column  
                        align="center"
                        prop="vip_info.vip_points"
                        label="会员积分"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column label="操作" align="center" fixed="right" width="230" >

                        <template slot-scope="scope">
                            <el-button
                                size="mini"
                                type="danger"
                                @click="upgradeToBusiness(scope.row)">升级为员工</el-button>
                        </template>
                    </el-table-column>

                </el-table>

                <el-pagination
                @current-change="changeCurrent"
                :current-page="iCurrentPage"
                :page-size="10"
                layout="total, prev, pager, next, jumper"
                :total="iMaxTotal"
                style="text-align:right; margin-top:15px"
                >
                </el-pagination>

            </div>

        <el-dialog :visible.sync="b_show_dialog" :fullscreen="b_show_fullscreen" :show-close="false">
            <div slot="title" class="dialog-title">
                <span style="font-size: 18px; line-height: 24px; color: #303133;">{{ s_dialog_name }}</span>
                <el-button icon="el-icon-close" class='dialog-title-button' @click="b_show_dialog = false"></el-button>
                <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_show_fullscreen = !b_show_fullscreen"></el-button>
            </div>

            <el-row :gutter="15">
                <el-form :model="d_dialog_data" ref="d_dialog_data" label-width="100px" @class="demo-d_dialog_data">
                
                <el-col :span="12">
                    <el-form-item label='用户名' prop="username">
                    <el-input v-model="d_dialog_data.username" placeholder="请输入用户名" :disabled="b_disabled"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label='邮箱' prop="email">
                    <el-input v-model="d_dialog_data.email" placeholder="请输入邮箱" :disabled="b_disabled"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label='手机号' prop="phone_num">
                    <el-input v-model="d_dialog_data.phone_num" placeholder="请输入手机号" :disabled="b_disabled"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label='密码' prop="password" v-show="password_disabled">
                    <el-input v-model="d_dialog_data.password" placeholder="请输入密码" :disabled="b_disabled" ></el-input>
                    </el-form-item>
                </el-col>
                
                <el-col :span="12">
                    <el-form-item label='部门' prop="department_id">
                    
                    <el-input type="text" v-model="d_dialog_data.department_name"
                    placeholder="请选择部门" :disabled="b_disabled" 
                    :style="{width: '100%'}" @focus="select_department"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="超级管理员" prop="is_super_admin">
                    <el-switch v-model="d_dialog_data.is_super_admin" :disabled="b_disabled"></el-switch>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label='岗位' prop="job_list">
                    <el-select v-model="d_dialog_data.job_list" multiple placeholder="请选择岗位" :disabled="b_disabled" :style="{width: '100%'}">
                        <el-option
                        v-for="item in l_job_list"
                        :key="item.job_id"
                        :label="item.job_name"
                        :value="item.job_id">
                        </el-option>
                    </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="15">
                    <el-form-item>
                    <el-button type="primary" @click="upgradeToBusinessFucn()" :disabled="b_disabled">{{ s_dialog_btn_name }}</el-button>
                    <el-button @click="cancel_func">取消</el-button> 
                    </el-form-item>
                </el-col>
                </el-form>

            </el-row>
            
        </el-dialog>

        <el-dialog :visible.sync="b_department_dialog" :fullscreen="b_show_department_fullscreen" :show-close="false" width="500px">
            <div slot="title" class="dialog-title">
                <span style="font-size: 18px; line-height: 24px; color: #303133;">选择部门</span>
                <el-button icon="el-icon-close" class='dialog-title-button' @click="b_department_dialog = false"></el-button>
                <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_show_department_fullscreen = !b_show_fullscreen"></el-button>
            </div>
            
            <el-tree 
                :data="l_department_tree_data"
                :props="defaultProps" 
                default-expand-all
                highlight-current-row
                :expand-on-click-node="false"
                @node-click="select_department_func">
            </el-tree>

            <div class="common-pidding">
                <el-button type="primary" @click="select_department_submit">确定</el-button> 
                <el-button @click="select_department_cancel">取消</el-button> 
            </div>
        </el-dialog>
    
        </div>

        <div v-else>
            <div style="text-align: center;">
                <div style="margin-top: 0px;">
                <img src="../assets/permission_denied.png">
                <div style="margin-top: 20px;">
                    <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
                </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
export default {
    name: "coupon_system",
    data(){
        return {
            is_super_admin: false,
            iCurrentPage: 1,
            iMaxTotal: 10,
            userList: [],
            dUserSearch: {
                username: '',
                phone_num: '',
            },

            // 弹窗相关数据
            b_show_dialog: false,
            b_show_fullscreen: false,
            b_disabled: false,
            s_dialog_name: '',
            s_dialog_btn_name: '',
            d_dialog_data: {},
            b_dialog_type: 1,
            password_disabled: false,

            // 岗位和部门相关数据
            l_job_list: [],
            l_department_data: [],
            l_department_tree_data: [],
            defaultProps:{children: 'children', label: 'department_name'},

            // 选择岗位弹窗
            b_department_dialog: false,
            b_show_department_fullscreen: false,
            s_select_department_name: '',
            s_select_department_id: '',

        }
    },

    mounted() {
        // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
        let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
        if (isSuperAdmin == "false") {
            this.is_super_admin = false
            return
        } else {
        this.is_super_admin = true
        }
        this.resUserTableData()

        this.ref_job_list()

        // 刷新部门数据并转换树结构
        this.ref_department_data()


    },

    methods: {

        // 获取岗位列表
        async ref_job_list(){
            let d_job_data = {'job_status': '正常'}
            let res = await this.$axios.get('/api/job/', {params: d_job_data})
            if(res.status == 200){
                this.l_job_list = res.data
            }
        },

        // 刷新部门数据并转换为树结构
        async ref_department_data(){
            let d_query_data = {"department_detail": '正常'}
            let res = await this.$axios.get('/api/department/', {params: d_query_data})
            this.l_department_data = res.data
            this.l_department_tree_data = this.toTree(this.l_department_data, 'department_id', 'parent_id');
            
            },
            // 转换数据为树形结构
            toTree(objects, keyName, parentKeyName) {
    
            if (!keyName) {
            throw "keyName argument is required";
            }

            if (!parentKeyName) {
            throw "parentKeyName argument is required";
            }

            // 列表项字典 将数组变成以objectId分组的对象，类似于{Vvwkeujpo:{},Rohdsfdofj:{}}
            var map = {};
            objects.forEach(x => (map[x[keyName]] = Object.assign({}, x)));
            
            // 已添加到父项的键
            var pushed = {};

            // 遍历列表项，将子项添加到父项的 children 数组
            for (const key in map) {
            if (map.hasOwnProperty(key)) {// 这样就可以过滤掉原型链上的可枚举属性了
                const x = map[key];
                if (x && x[keyName] && x[parentKeyName]) {
                var parent = map[x[parentKeyName]];
                if (parent) {
                    if (!parent.children) {
                    parent.children = [];
                    }
                    parent.children.push(x);
                    pushed[x[keyName]] = true;
                    }
                }
                }
            }
    
            // 排除已添加到父项的项得到树
            var tree = [];
            for (const key in map) {
                if (map.hasOwnProperty(key)) {
                    const x = map[key];
                    if (!pushed[x[keyName]]) {
                    tree.push(x);
                }
                }
            }
            return tree;
        },

        // 刷新人员信息
        async resUserTableData() {
            let params = {
                'page': this.iCurrentPage,
                'page_size': 10,
                'is_business': 0,
            }
            if(this.dUserSearch.username){
                params.username = this.dUserSearch.username;
            }
            if(this.dUserSearch.phone_num){
                params.phone_num = this.dUserSearch.phone_num;
            }
            let res = await this.$axios.get('/api/users/', {params: params});
            this.userList = res.data.results;
            this.iMaxTotal = res.data.count;
        },

        // 分页事件
        changeCurrent(val){
            this.iCurrentPage = val;
            this.resUserTableData();
        },

        // 搜索人员信息
        async searchUser(){
            this.iMaxTotal = 10;
            this.resUserTableData();

        },

        // 重置搜索栏
        onReset(){
            this.dUserSearch.username = '';
            this.dUserSearch.phone_num = '';
            this.iMaxTotal = 10;
            this.resUserTableData();
        },

        upgradeToBusiness(row){
            this.b_show_fullscreen = false
            this.b_show_dialog = true
            this.s_dialog_name = '新增用户'
            this.s_dialog_btn_name = '新增'
            this.b_dialog_type = 1
            this.password_disabled = true
            this.b_disabled = false
            this.d_dialog_data = JSON.parse(JSON.stringify(row))
            
        },

        cancel_func(){
            this.b_show_dialog = false
            this.d_dialog_data = {}
        },

        // 选择部门
        select_department(){
            console.log(123)
            this.b_department_dialog = true
        },

        // 弹窗选择部门事件
        select_department_func(row){
            console.log(row)
            // this.b_department_dialog = false
            this.s_select_department_name = row.department_name
            this.s_select_department_id = row.department_id
            console.log(this.s_select_department_name)
            },

        // 弹窗选择岗位事件-确定
        select_department_submit(){
            console.log(this.s_select_department_name)
            this.b_department_dialog = false
            // this.d_dialog_data.set
            this.$set(this.d_dialog_data, 'department_name', this.s_select_department_name)
            this.$set(this.d_dialog_data, 'department_id', this.s_select_department_id)
            },

            // 弹窗选择岗位事件-取消
            select_department_cancel(){
            this.b_department_dialog = false
            this.s_select_department_name = ''
        },

        // 升级为员工
        async upgradeToBusinessFucn(){
            let data = this.d_dialog_data

            if (data.password == '' || data.password == null){
                this.$message.error('密码不能为空')
                return
            }

            if (data.username == '' || data.username == null){
                this.$message.error('用户名不能为空')
                return
            }

            if (data.phone_num == '' || data.phone_num == null){
                this.$message.error('手机号不能为空')
                return
            }

            if (data.department_id == '' || data.department_id == null){
                this.$message.error('部门不能为空')
                return
            }

            if (data.job_list == [] || data.job_list == null){
                this.$message.error('岗位不能为空')
                return
            }


            // let password_confirm = this.d_dialog_data.password
            // data.password_confirm = this.d_dialog_data.password
            this.$set(data, 'password_confirm', this.d_dialog_data.password)
            // data.password_confirm = 
            var _this = this
            this.$confirm('此操作将雇佣该员工, 员工身份信息不回被删除, 将记录在员工管理信息中, 是否继续?', '雇佣员工警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'error'
            }).then(() => {
            data.is_business = 1
            data.is_dismissal = false
            _this.$axios.patch('/api/users/' + data.id + '/', data).then(
                function(res){
                _this.$message({
                    type: 'success',
                    message: '升级为员工成功'
                });
                _this.resUserTableData()
                _this.b_show_dialog = false
                }
            )
            }).catch(() => {
                // 打印错误

            _this.$message({
                type: 'info',
                message: '雇佣失败,请检查是否有未设置的信息'
            });          
            });
        }

    }
    

}
</script>

<style>

</style>
